import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../../01_atoms/Link';
import Button from '../../../../01_atoms/Button';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../../01_atoms/DefaultPicture';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';

import styles from './index.module.scss';
import gStyles from '../index.module.scss';

const BBCTAActivism = ({
  imagePicture,
  button,
  title,
  list,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb cta ${gStyles['cta']} ${styles['bb-activism-cta']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    data-component="bb-activism-cta"
    id={uuid}
  >
    <div className={styles['bb-activism-cta__image']}>
      <DefaultPicture {...imagePicture} loading="lazy" />
    </div>

    <div className={styles['bb-activism-cta__info-wrapper']}>
      <div className="container">
        <div className={styles['bb-activism-cta__info']}>
          <h2 className={styles['bb-activism-cta__title']}>{title}</h2>

          <div className={styles['bb-activism-cta__text']}>
            {list.map((item, i) => (
              <p key={`list-item-${item}`}>{item}</p>
            ))}
          </div>

          <div className={styles['bb-activism-cta__action']}>
            <Link {...button.nextLink}>
              <Button
                tag="a"
                href={button.nextLink.url}
                isExternal={button.isExternal}
                target={button.isExternal ? '_blank' : undefined}
              >
                {button.label}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);

BBCTAActivism.propTypes = {
  imagePicture: PropTypes.shape(picturePropTypes).isRequired,
  title: PropTypes.string.isRequired,
  button: PropTypes.shape({
    label: PropTypes.string.isRequired,
    nextLink: PropTypes.shape(linkPropTypes).isRequired,
    isExternal: PropTypes.bool,
  }).isRequired,
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBCTAActivism;
